import { NavigationTabsItem } from '@app/components/ui/navigation-tabs/navigation-tabs';
import { navigationRoutes } from '@app/utils/navigation-routes';

export const navigationData: (id: string | undefined) => Array<NavigationTabsItem> = (id) => [
  {
    index: 'main settings',
    link: `/${navigationRoutes.analytics}/${id}`,
    icon: 'SettingIcon',
    label: 'main_settings',
    dataId: 'ap-section-basic-settings',
  },
  {
    index: 'preset',
    link: `/${navigationRoutes.analytics}/${id}/${navigationRoutes.presets}`,
    icon: 'MenuSmallIcon',
    label: 'preset',
    dataId: 'ap-section-preset',
  },
  {
    index: 'metrics',
    link: `/${navigationRoutes.analytics}/${id}/${navigationRoutes.metric}`,
    icon: 'ChartIcon',
    label: 'metrics',
    dataId: 'ap-section-metrics',
  },
  {
    index: 'triggers',
    icon: 'RollbackIcon',
    label: 'triggers',
    link: `/${navigationRoutes.analytics}/${id}/${navigationRoutes.triggers}`,
    dataId: 'ap-section-project-triggers',
  },
  {
    index: 'projectRecords',
    link: `/${navigationRoutes.analytics}/${id}/${navigationRoutes.projectRecords}`,
    icon: 'PlayCircleIcon',
    label: 'project_records',
    dataId: 'ap-section-project-recordings',
  },
  {
    index: 'reports',
    icon: 'MetricIcon',
    link: `/${navigationRoutes.analytics}/${id}/${navigationRoutes.reports}`,
    label: 'reports',
    dataId: 'ap-section-reports',
  },
];
